module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./VerifyView.js"));
	}, "BankCardVerifyView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BankCardVerifyView!./src/pages/Shop/Member/Wallet/BankCard/Verify/VerifyView.js
// module id = 1079
// module chunks = 431